import { render, staticRenderFns } from "./txtarea.vue?vue&type=template&id=034c64ca&scoped=true&"
import script from "./txtarea.vue?vue&type=script&lang=js&"
export * from "./txtarea.vue?vue&type=script&lang=js&"
import style0 from "./txtarea.vue?vue&type=style&index=0&id=034c64ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034c64ca",
  null
  
)

export default component.exports